import { $t } from '@/i18n';
import SchemaDefault from './xy-modal-schema-default.js';
export default {
  type: 'object',
  fields: [
    {
      id: 'attr',
      title: $t('k_6de62429'),
      type: 'string',
      'uc:allowExpr': false,
      'uc:allowReset': false,
      group: $t('k_6de62429'),
      ui: { type: 'PageletAttr' },
      condition: 'designer.pageletId!=="default"',
    },
    {
      id: 'type',
      title: $t('k_86587150'),
      type: 'string',
      'uc:allowExpr': false,
      default: SchemaDefault.type,
      group: $t('k_3b38ba37'),
      enum: [
        { value: 'modal', label: $t('k_ab346fdc') },
        { value: 'drawer', label: $t('k_19344599') },
        { value: 'adaptation', label: $t('k_55534ba') },
      ],
    },
    {
      id: 'drawerPlacement',
      title: $t('k_7bc6ba9c'),
      type: 'string',
      group: $t('k_3b38ba37'),
      'uc:allowExpr': false,
      default: SchemaDefault.drawerPlacement,
      enum: [
        { value: 'top', label: $t('k_57e47023') },
        { value: 'right', label: $t('k_f7146b42') },
        { value: 'bottom', label: $t('k_34d6ee68') },
        { value: 'left', label: $t('k_71407e53') },
      ],
      condition: 'props.type === "drawer" || props.type === "adaptation"',
    },
    {
      id: 'width',
      title: $t('k_6b927d0f'),
      type: 'string',
      group: $t('k_3b38ba37'),
      default: SchemaDefault.width,
      ui: {
        type: 'XyModalSizeEditor',
        unitOptions: [
          { value: 'px', label: 'px' },
          { value: 'vw', label: 'vw' },
          { value: '%', label: '%' },
        ],
      },
      condition: 'props.type === "modal" || props.type === "adaptation" || props.drawerPlacement === "right" || props.drawerPlacement === "left"',
    },
    {
      id: 'height',
      title: $t('k_c8f018b2'),
      type: 'string',
      group: $t('k_3b38ba37'),
      default: SchemaDefault.width,
      ui: {
        type: 'XyModalSizeEditor',
        unitOptions: [
          { value: 'px', label: 'px' },
          { value: 'vh', label: 'vh' },
          { value: '%', label: '%' },
        ],
      },
      condition: '(props.type === "drawer" || props.type === "adaptation") && (props.drawerPlacement === "top" || props.drawerPlacement === "bottom")',
    },
    {
      id: 'withTitle',
      title: $t('k_801a9847'),
      type: 'boolean',
      group: $t('k_3b38ba37'),
      'uc:allowExpr': false,
      default: SchemaDefault.withTitle,
    },
    {
      id: 'withFooter',
      title: $t('k_6a4f4221'),
      type: 'boolean',
      group: $t('k_3b38ba37'),
      'uc:allowExpr': false,
      default: SchemaDefault.withFooter,
    },
    {
      id: 'isTitleSlot',
      title: $t('k_cb14571a'),
      type: 'boolean',
      group: $t('k_10eb0273'),
      'uc:allowExpr': false,
      default: SchemaDefault.isTitleSlot,
      condition: '!!props.withTitle',
    },
    {
      id: 'title',
      title: $t('k_10eb0273'),
      type: 'string',
      group: $t('k_10eb0273'),
      default: SchemaDefault.title,
      condition: '!props.isTitleSlot && props.withTitle',
    },
    {
      id: 'withClosableIcon',
      title: $t('k_80ff7ac4'),
      type: 'boolean',
      group: $t('k_a1567091'),
      'uc:allowExpr': false,
      default: SchemaDefault.withClosableIcon,
    },
    {
      id: 'mask',
      title: $t('k_23cfb0c'),
      type: 'boolean',
      group: $t('k_a1567091'),
      'uc:allowExpr': false,
      default: SchemaDefault.mask,
    },
    {
      id: 'maskClosable',
      title: $t('k_850dcf5e'),
      type: 'boolean',
      group: $t('k_a1567091'),
      'uc:allowExpr': false,
      default: SchemaDefault.maskClosable,
      condition: 'props.mask',
    },
    {
      id: 'keyboard',
      title: $t('k_9a79a966'),
      type: 'boolean',
      group: $t('k_a1567091'),
      'uc:allowExpr': false,
      default: SchemaDefault.keyboard,
      condition: 'props.mask',
    },
    {
      id: 'keepAlive',
      title: $t('k_ba401173'),
      type: 'boolean',
      group: $t('k_a1567091'),
      'uc:allowExpr': false,
      default: SchemaDefault.keepAlive,
      condition: 'designer.pageletId!=="default"',
    },
    {
      id: 'defaultCloseParams',
      type: 'array',
      group: $t('k_92eb515a'),
      title: $t('k_efc8842c'),
      ui: {
        type: 'XyPageletPropsEditor',
        props: {
          keyIsInteropable: true,
        },
      },
      items: {
        type: 'object',
        fields: [
          { id: 'key', type: 'string' },
          { id: 'value', type: 'string' },
        ],
      },
    },
  ],
};
